import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Checkbox } from 'antd';
import axios from 'axios';
import { TableCard, Table } from 'components';
import Scrolling from "devextreme-react/data-grid";
// import Box from '@mui/material/Box';

function System_Settings() {
  const [forms, setForms] = useState([]);
  const [columns,setColumns] = useState([])
  const [roleForms, setRoleForms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const [actionLoading, setActionLoading] = useState(false);
  const tableRef = useRef(null)

  useEffect(() => {
    getForms();
    getData();
  }, []);

      const getForms = () => {
      setLoading(true);
      axios({
        method: 'get',
        url: '/system-forms'
      })
        .then((res) => {
          setColumns(res.data);
        })
        .catch((err) => {
          console.error('Error fetching forms:', err);
        })
        .finally(() => setLoading(false));
    };

    const getData = () => {
      setLoading(true);
      axios({
        method: 'get',
        url: '/system-role-forms'
      })
        .then((res) => {
          setRoleForms(res.data);
          initializeCheckedItems(res.data);  
        })
        .catch((err) => {
          console.error('Error fetching role forms:', err);
        })
        .finally(() => setLoading(false));
    };

    const sendUpdatedData = (data) => {
      setActionLoading(true);
      axios({
        method: 'put',
        url: '/system-form',
        data: data
      })
        .then((res) => {
          getData();  
        })
        .catch((err) => {
          console.error('Error updating data:', err);
        })
        .finally(() => {
          setActionLoading(false);
        });
    };

    const initializeCheckedItems = (data) => {
      let initialCheckedItems = {};
      data.map((permission) => {
        initialCheckedItems[permission.id] = permission
      })
      setCheckedItems(initialCheckedItems);  
    };
    

    const handleCheckChange = (id, e, data1) => {
      setLoading(true)
      const updatedCheckedItems = { ...checkedItems };
      
      updatedCheckedItems[data1.name] = {
        ...updatedCheckedItems[data1.name],
        [id]: e.target.checked,  
      };

      setCheckedItems(updatedCheckedItems);  

      let data = {
        roleid: data1.id,
        formid: id,
        value: e.target.checked,
      };
      sendUpdatedData(data);  
    };

  const fixedColumns = useMemo(() => {
    let tmp = [{
      title: 'Нэр ',
      dataIndex: 'name',
      key: 'name',
      width: 100,
      fixed: true,
    }];
    columns.forEach(x => {
      tmp.push({
        title: x.name,
        dataIndex: x.id,
        key: x.id,
        // width: 100,
        cellRender: ({ value, data }) => {
          // console.log(checkedItems[data.id])
          return (
            <Checkbox
              checked={checkedItems[data.id]?.[x.id]}  
              onChange={(e) => handleCheckChange(x.id, e, data)}   
              disabled={loading}
            />
          )
        },
      });
    });

    return tmp
  }, [columns, checkedItems])

  return (
    <TableCard
      header={
        <div className='flex flex-col'>
          <div className='w-full flex justify-between items-center gap-4'>
            <h1 className='text-2xl font-medium'>Системийн тохиргооны жагсаалт</h1>
          </div>
        </div>
      }
    > 
      <Table
        tableRef={tableRef}
        dataSource={roleForms}
        columns={fixedColumns}
        loading={loading}
        columnMinWidth={130}
        scrolling={true}
        tableClass='max-w-[calc(100vw-364px)]'
      />
    </TableCard>
  );
}

export default System_Settings;
